"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContainer = void 0;
const react_1 = __importDefault(require("react"));
const connect_1 = __importDefault(require("./connect"));
const util_1 = require("@app/util");
const modal_context_1 = require("@app/util/modal/modal-context");
const acountant_add_1 = require("./acountant-add");
const area_create_1 = require("./area-create");
const batch_actions_1 = require("./batch-actions");
const bonus_create_1 = require("./bonus-create");
const chat_1 = require("./chat");
const confirm_1 = __importDefault(require("./confirm"));
const connect_calendar_1 = require("./connect-calendar/connect-calendar");
const copy_period_1 = __importDefault(require("./copy-period"));
const copy_unavailability_1 = __importDefault(require("./copy-unavailability"));
const country_create_1 = require("./country-create");
const cycle_preset_1 = __importDefault(require("./cycle-preset"));
const cycle_select_1 = __importDefault(require("./cycle-select"));
const display_image_1 = __importDefault(require("./display-image"));
const edit_locality_1 = __importDefault(require("./edit-locality"));
const edit_shift_attribute_1 = __importDefault(require("./edit-shift-attribute"));
const ActionsTimeOffConflict_1 = require("./edit-unavailability/ActionsTimeOffConflict");
const employee_add_1 = __importDefault(require("./employee-add"));
const employee_card_v2_1 = require("./employee-card-v2/employee-card-v2");
const export_attendance_1 = __importDefault(require("./export-attendance"));
const export_excel_1 = __importDefault(require("./export-excel"));
const export_unavailability_requests_1 = __importDefault(require("./export-unavailability-requests"));
const language_select_1 = require("./language-select/language-select");
const mobile_application_1 = require("./mobile-application/mobile-application");
const news_feed_1 = require("./news-feed");
const offers_1 = __importDefault(require("./offers"));
const permissions_add_1 = require("./permissions-add");
const planning_1 = require("./planning");
const planning_finished_1 = __importDefault(require("./planning-finished"));
const plugin_detail_1 = __importDefault(require("./plugin-detail"));
const position_create_1 = require("./position-create");
const position_editor_1 = require("./position-editor");
const publish_changes_1 = __importDefault(require("./publish-changes"));
const request_offer_1 = __importDefault(require("./request-offer"));
const reset_password_1 = require("./reset-password/reset-password");
const setup_mfa_1 = require("./setup-mfa");
const template_apply_1 = __importDefault(require("./template-apply"));
const template_create_1 = __importDefault(require("./template-create"));
const terminal_create_1 = require("./terminal-create");
const transfer_group_create_1 = require("./transfer-group-create");
const unavailability_add_1 = require("./unavailability-add");
const unsupported_browser_1 = __importDefault(require("./unsupported-browser"));
const view_shift_as_employee_1 = __importDefault(require("./view-shift-as-employee"));
const workspace_create_1 = require("./workspace-create");
const workspace_select_1 = require("./workspace-select");
const displayCondition = (mode, index, length) => {
    switch (mode) {
        case 'all':
            return {
                display: 'initial',
            };
        case 'single':
            return index === 0 ? { display: 'initial' } : { display: 'none' };
        case 'stack':
            return index === length - 1 ? { display: 'initial' } : { display: 'none' };
    }
};
exports.ModalContainer = (0, connect_1.default)(({ modal, close, }) => {
    const context = react_1.default.useContext(modal_context_1.modalContext);
    // TODO: implement layer uuid in modal-context and render all layers above each other, setting display to none on inactive layers to preserve state
    if ((0, util_1.isDefined)(context) && context.layers.length > 0) {
        const layer = context.layers.at(-1);
        if ((0, util_1.isDefined)(layer)) {
            return (react_1.default.createElement(react_1.default.Fragment, null, layer.modals.map((modal, index) => {
                return (react_1.default.createElement("div", { key: modal.uuid, style: displayCondition(layer.mode, index, layer.modals.length) }, react_1.default.cloneElement(modal.element, { close: modal.onClose })));
            })));
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, modal &&
        react_1.default.cloneElement((() => {
            switch (modal.type) {
                case 'mobile-application':
                    return react_1.default.createElement(mobile_application_1.MobileApplication, null);
                case 'language-select':
                    return react_1.default.createElement(language_select_1.LanguageSelect, null);
                case 'connect-calendar':
                    return react_1.default.createElement(connect_calendar_1.ConnectCalendar, null);
                case 'reset-password':
                    return react_1.default.createElement(reset_password_1.ResetPassword, null);
                case 'view-shift-as-employee':
                    return react_1.default.createElement(view_shift_as_employee_1.default, null);
                case 'workspace-select':
                    return react_1.default.createElement(workspace_select_1.WorkspaceSelect, null);
                case 'export-excel':
                    return react_1.default.createElement(export_excel_1.default, null);
                case 'unsupported-browser':
                    return react_1.default.createElement(unsupported_browser_1.default, null);
                case 'planning-finished':
                    return react_1.default.createElement(planning_finished_1.default, null);
                case 'publish-changes':
                    return react_1.default.createElement(publish_changes_1.default, null);
                case 'confirm':
                    // @ts-expect-error
                    return react_1.default.createElement(confirm_1.default, null);
                case 'export-attendance':
                    return react_1.default.createElement(export_attendance_1.default, null);
                case 'export-unavailability-request':
                    return react_1.default.createElement(export_unavailability_requests_1.default, null);
                case 'offers':
                    return react_1.default.createElement(offers_1.default, null);
                case 'request-offer':
                    return react_1.default.createElement(request_offer_1.default, null);
                case 'news-feed':
                    return react_1.default.createElement(news_feed_1.NewsFeedModal, null);
                case 'display-image':
                    return react_1.default.createElement(display_image_1.default, null);
                case 'edit-shift-attribute':
                    return react_1.default.createElement(edit_shift_attribute_1.default, null);
                case 'edit-locality':
                    return react_1.default.createElement(edit_locality_1.default, null);
                case 'extra-locality':
                    // @ts-expect-error
                    return react_1.default.createElement(edit_locality_1.default, { newLocality: true });
                case 'copy-period':
                    return react_1.default.createElement(copy_period_1.default, null);
                case 'copy-unavailability':
                    return react_1.default.createElement(copy_unavailability_1.default, null);
                case 'template-create':
                    return react_1.default.createElement(template_create_1.default, null);
                case 'template-apply':
                    return react_1.default.createElement(template_apply_1.default, null);
                case 'cycle-select':
                    return react_1.default.createElement(cycle_select_1.default, null);
                case 'cycle-preset':
                    return react_1.default.createElement(cycle_preset_1.default, null);
                case 'employee-profile':
                    // @ts-expect-error
                    return react_1.default.createElement(employee_card_v2_1.EmployeeCardV2, null);
                case 'employee-profile-v2':
                    // @ts-expect-error
                    return react_1.default.createElement(employee_card_v2_1.EmployeeCardV2, null);
                case 'employee-add':
                    return react_1.default.createElement(employee_add_1.default, null);
                case 'plugin-detail':
                    // @ts-expect-error
                    return react_1.default.createElement(plugin_detail_1.default, null);
                case 'unavailability-add':
                    // @ts-expect-error initialData is missing
                    return react_1.default.createElement(unavailability_add_1.UnavailabilityAdd, null);
                case 'countries-create':
                    return react_1.default.createElement(country_create_1.CountryCreate, null);
                case 'areas-create':
                    return react_1.default.createElement(area_create_1.AreaCreate, null);
                case 'workspace-create':
                    return react_1.default.createElement(workspace_create_1.WorkspaceCreate, null);
                case 'position-create':
                    return react_1.default.createElement(position_create_1.PositionCreate, null);
                case 'permission-add':
                    return react_1.default.createElement(permissions_add_1.PermissionsAdd, null);
                case 'bonus-create':
                    return react_1.default.createElement(bonus_create_1.BonusesCreate, null);
                case 'batch-actions':
                    return react_1.default.createElement(batch_actions_1.BatchActions, null);
                case 'transfer-group-create':
                    return react_1.default.createElement(transfer_group_create_1.TransferGroupCreate, null);
                case 'planning':
                    return react_1.default.createElement(planning_1.Planning, null);
                case 'position-editor':
                    return react_1.default.createElement(position_editor_1.PositionEditorModal, null);
                case 'accountant-add':
                    return react_1.default.createElement(acountant_add_1.AcountantAdd, null);
                case 'timeoff-conflict':
                    // @ts-expect-error
                    return react_1.default.createElement(ActionsTimeOffConflict_1.ActionsTimeOffConflict, null);
                case 'terminal-create':
                    // @ts-expect-error
                    return react_1.default.createElement(terminal_create_1.TerminalCreate, null);
                case 'setup-mfa':
                    return react_1.default.createElement(setup_mfa_1.SetupMFA, null);
                case 'channel-editor':
                    return react_1.default.createElement(chat_1.ChannelEditor, null);
                case 'channel-creator':
                    return react_1.default.createElement(chat_1.ChannelCreator, null);
                default:
                    return react_1.default.createElement(react_1.default.Fragment, null);
            }
        })(), Object.assign({}, { close: modal.onCancel || close }, // pass the the close() function or custom onCancel() function, if it exists, to the modal component
        modal.data // pass data from modal.data to the modal component as props
        ))));
});
